const fontFamily = 'sans-serif';

const theme = {
  fontFamily,
};

export default theme;
